import { Box, Tooltip, Typography } from '@mui/material';
import { TagBadge } from './TagBadge';

// The first `max` tags as badges, the rest as "+N" with the names on hover.
// Shared by the event wallet rows and the trader search rows.
export function TagBadges({
    tags,
    dataIssues,
    max = 2,
}: {
    tags: readonly string[];
    dataIssues?: readonly string[];
    max?: number;
}) {
    const hiddenTags = tags.slice(max);
    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 0.5,
                overflow: 'hidden',
                minWidth: 0,
            }}
        >
            {tags.slice(0, max).map(tag => (
                <TagBadge key={tag} tag={tag} dataIssues={dataIssues} />
            ))}
            {hiddenTags.length > 0 && (
                <Tooltip title={hiddenTags.join(', ')}>
                    <Typography
                        sx={{
                            fontSize: '11px',
                            color: 'text.secondary',
                            whiteSpace: 'nowrap',
                        }}
                    >
                        +{hiddenTags.length}
                    </Typography>
                </Tooltip>
            )}
        </Box>
    );
}
